module.exports = __webpack_public_path__ + "static/media/inside_back_picture.d5e4fc9f.jpg";